<template lang="pug">
  .orders.xs-12
    FixedWidthTweakUpper
      .top-wrap.section
        .xs-12
          BackButton(url="/dashboard/purchases")

        .title-wrap.xs-12.text-center
          SectionTitle(text="All Purchases")

      .order-wrap.section(v-for="order in orders")
        .order-status-wrap.xs-12
          p.order-placed.color-slate.xs-f-small.max-at-tweak Placed on {{order.invoice.paid_at || order.invoice.created_at | moment("MMMM&nbsp;Do&nbsp;YYYY")}}
          p.order-status.capitalize.semi-bold.xs-f-medium.lg-f-xmedium.max-at-tweak {{order.invoice.order_status}}
          router-link.pull-right.xs-f-small.max-at-tweak(:to="'/dashboard/purchases/order-details/' + order.invoice.id" data-mr-ass="see-details-button") See Details
          a.capitalize.block.xs-f-small(v-if="order.invoice.locationData" :href="'/colorbar/booking/' + order.invoice.locationData.code") {{order.invoice.locationData.name}}

        InvoiceItem(v-for="item in order.invoice.items" :item="item" :key="item.id").xs-12.md-3

      .order-loader.section.text-center(v-if="!lastPage")
        visible-trigger(@visible="nextPage" v-if="!loadingOrders && !lastPage")
        p.xs-f-small.max-at-tweak loading orders...

      ExpertiseIncluded

</template>

<script>
  import vueCustomerSvc from "../../../../services/vueCustomerSvc";
  import SectionBlock from '../../SectionBlock';
  import ExpertiseIncluded from '../../../ExpertiseIncluded';
  import BackButton from "../../BackButton";
  import SectionTitle from "../../../SectionTitle";
  import InvoiceItem from "../../Welcome/ReturnCustomer/InvoiceItem/InvoiceItem";
  import FixedWidthTweakUpper from "../../../FixedWidthTweakUpper";

  export default {
    name: 'Orders',

    components: {
      FixedWidthTweakUpper,
      InvoiceItem,
      SectionTitle,
      BackButton,
      SectionBlock,
      ExpertiseIncluded
    },

    data() {
      return {
        pageNumber: 0,
        pageSize: 5,
        orders: [],
        loadingOrders: false,
        lastPage: false
      }
    },

    methods: {
      nextPage() {
        if (this.lastPage) {
          return;
        }
        this.loadingOrders = true;

        vueCustomerSvc.getPaginatedPurchaseHistory(this.pageNumber, this.pageSize).then(res => {
          res.data.orders.forEach(order => {
            this.orders.push(order);
          });

          if (!res.data.next) {
            this.lastPage = true;
          }

          this.pageNumber += 1;
          this.loadingOrders = false;
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .orders
    .top-wrap
      border-bottom none !important
      margin-bottom 0 !important
      border-bottom-left-radius 0px !important
      border-bottom-right-radius 0px !important

      .title-wrap
        padding-top 1em

    .order-wrap
    .order-loader
      &:nth-child(2)
        border-top none !important
        margin-top 0px !important
        border-top-left-radius 0 !important
        border-top-right-radius 0 !important

    .order-wrap
      padding 1.5em 5%
      margin-bottom 1.5em
      background-color color-white
      border 1px solid color-fog-light
      border-radius 8px

      &:last-child
        margin-bottom 0.5em

      .order-status-wrap
        padding-bottom 1em

      .order-status
        max-width 12em
        display inline-block
        vertical-align top

    @media mq-mobile
      .all-purchases
        padding 0

      .top-wrap
        border none
        border-radius 0
        border-top 1px solid color-fog-light

      .order-wrap
        border-radius 0
        border-left none
        border-right none

    @media mq-tablet
      .section
      .section-link
        padding 1.5em 10% !important

    @media mq-desktop-md
      .section
      .section-link
        padding 1.5em 8% !important

    @media mq-desktop-plus
      .section
      .section-link
        padding 1.5em 10% !important

      .order-wrap
        padding 1.5em 8%

</style>
